<template>
  <div>
    <NavBar />
    <Header />
    <v-container>
        <v-row v-if="checkGoodsLen">
          <v-col>
            <keep-alive>
              <ProductGrid :products="goodsList" />
            </keep-alive>
          </v-col>
        </v-row>

        <v-row justify="center" class="my-10">
          <v-btn color="grey" dark="" @click="loadMore()">{{$t('mall.loadMore')}}</v-btn>
        </v-row>

        <v-row v-if="!checkGoodsLen"
          style="background:url(../../static/404.png) no-repeat center;"
        ></v-row>
    </v-container>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import Header from '@/components/Header.vue';
import ProductGrid from '@/components/product/ProductGrid.vue';
import { processImage } from '../utils/product';

export default {
  components: {
    NavBar,
    Header,
    ProductGrid
  },
  data() {
    return {
      sortFlag: '',
      busy: false,
      reqProductParams: {
        pageNum: 1,
        pageSize: 8,
      },
    };
  },
  mounted() {
    this.$store.dispatch('requestProducts', { params: { ...this.reqProductParams, ...this.$route.query } });
  },

  computed: {
    goodsList() {
      return this.$store.getters['getProducts'];
    },
    checkGoodsLen() {
      return this.$store.getters['getProducts'].length > 0;
    },
  },
  methods: {
    processImage,
    loadMore() {
      this.busy = true;
      this.reqProductParams.pageNum += 1;
      this.$store.dispatch('requestProducts', {
        params: this.reqProductParams,
        loadMoreFlag: true,
      });
    },
  },
};
</script>